// extracted by mini-css-extract-plugin
module.exports = {"inner":"EditorFooter_inner__2oQdt","errorLogs":"EditorFooter_errorLogs__k_vUy"};